import { NgModule } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { MaterialModule } from '../../material/material.module';

@NgModule({
  declarations: [],
  imports: [
    MaterialModule
  ]
})
export class IconModule {
  private path = '../../../assets/images';

  constructor(
    private sanitizer: DomSanitizer,
    public matIconRegistry: MatIconRegistry) {
    this.matIconRegistry
      .addSvgIcon('close-panel', this.setPath(`${this.path}/close-share-panel.svg`))
      .addSvgIcon('chevron-right', this.setPath(`${this.path}/chevron-right.svg`))
      .addSvgIcon('info', this.setPath(`${this.path}/info.svg`))
      .addSvgIcon('chevron-up', this.setPath(`${this.path}/icon-chevron-up.svg`))
      .addSvgIcon('chevron-down', this.setPath(`${this.path}/icon-chevron-down.svg`))
      .addSvgIcon('alert-triangle-fill', this.setPath(`${this.path}/alert-triangle-fill.svg`))
      .addSvgIcon('close-circle', this.setPath(`${this.path}/icon-close-circle.svg`))
      .addSvgIcon('close-circle-fill', this.setPath(`${this.path}/27-icon-close-circle-fill.svg`))
      .addSvgIcon('icon-person-fill', this.setPath(`${this.path}/icon-person-fill.svg`))
      .addSvgIcon('share-doc-icon', this.setPath(`${this.path}/share-icon.svg`))
      .addSvgIcon('save-folder-icon', this.setPath(`${this.path}/27-icon-folder-fill.svg`))
      .addSvgIcon('saved-folder-icon-white', this.setPath(`${this.path}/27-icon-folder-saved.svg`))
      .addSvgIcon('saved-folder-icon-green', this.setPath(`${this.path}/27-icon-folder-saved-green.svg`))
      .addSvgIcon('add-folder-icon', this.setPath(`${this.path}/27-icon-folder-add-fill.svg`))
      .addSvgIcon('add-folder-icon-primary-500', this.setPath(`${this.path}/27-icon-folder-add-fill-primary-500.svg`))
      .addSvgIcon('edit-icon', this.setPath(`${this.path}/icon-edit.svg`))
      .addSvgIcon('trash-icon', this.setPath(`${this.path}/27-icon-trash-2.svg`))
      .addSvgIcon('picture-icon', this.setPath(`${this.path}/27-icon-image-fill.svg`))
      .addSvgIcon('arrowhead-left-icon', this.setPath(`${this.path}/arrowhead-left.svg`))
      .addSvgIcon('arrowhead-right-icon', this.setPath(`${this.path}/arrowhead-right.svg`))
      .addSvgIcon('arrow-ios-left-icon', this.setPath(`${this.path}/arrow-ios-left.svg`))
      .addSvgIcon('arrow-ios-right-icon', this.setPath(`${this.path}/arrow-ios-right.svg`))
      .addSvgIcon('arrow-ios-up', this.setPath(`${this.path}/arrow-ios-up.svg`))
      .addSvgIcon('arrow-ios-down', this.setPath(`${this.path}/arrow-ios-down.svg`))
      .addSvgIcon('plus-circle-icon', this.setPath(`${this.path}/icon-plus-circle.svg`))
      .addSvgIcon('plus-circle-icon-fill', this.setPath(`${this.path}/27-icon-plus-circle-fill.svg`))
      .addSvgIcon('minus-circle-icon', this.setPath(`${this.path}/icon-minus-circle.svg`))
      .addSvgIcon('arrow-circle-right-fill', this.setPath(`${this.path}/27-icon-arrow-circle-right-fill.svg`))
      .addSvgIcon('arrow-circle-left-fill', this.setPath(`${this.path}/27-icon-arrow-circle-left-fill.svg`))
      .addSvgIcon('article', this.setPath(`${this.path}/27-icon-article.svg`))
      .addSvgIcon('calendar', this.setPath(`${this.path}/27-icon-calendar.svg`))
      .addSvgIcon('website', this.setPath(`${this.path}/27-icon-globe.svg`))
      .addSvgIcon('search', this.setPath(`${this.path}/27-icon-search.svg`))
      .addSvgIcon('docs', this.setPath(`${this.path}/27-icon-docs.svg`))
      .addSvgIcon('docs-primary-500', this.setPath(`${this.path}/27-icon-docs-primary-500.svg`))
      .addSvgIcon('docs-basic-600', this.setPath(`${this.path}/27-icon-docs-basic-600.svg`))
      .addSvgIcon('pin', this.setPath(`${this.path}/27-icon-pin.svg`))
      .addSvgIcon('pin-basic-600', this.setPath(`${this.path}/27-icon-pin-basic-600.svg`))
      .addSvgIcon('share-white', this.setPath(`${this.path}/27-icon-share-white.svg`))
      .addSvgIcon('export-white', this.setPath(`${this.path}/27-icon-export-white.svg`))
      .addSvgIcon('hide-600', this.setPath(`${this.path}/27-icon-minus-circle-600.svg`))
      .addSvgIcon('help', this.setPath(`${this.path}/27-icon-question-mark-circle.svg`))
      .addSvgIcon('external-link', this.setPath(`${this.path}/27-icon-external-link.svg`))
      .addSvgIcon('icon-close', this.setPath(`${this.path}/27-icon-close.svg`))
      .addSvgIcon('pagination-left-basic-800', this.setPath(`${this.path}/btn-pagination-gauche.svg`))
      .addSvgIcon('pagination-right-basic-800', this.setPath(`${this.path}/btn-pagination-droite.svg`))
      .addSvgIcon('refresh-basic-800', this.setPath(`${this.path}/27-icon-refresh-basic-800.svg`))
      .addSvgIcon('menu-arrow-basic-800', this.setPath(`${this.path}/27-icon-menu-arrow-basic-800.svg`))
      .addSvgIcon('edit-800', this.setPath(`${this.path}/27-icon-search-ctrl-f.svg`))
      .addSvgIcon('edit-500', this.setPath(`${this.path}/27-icon-search-ctrl-f-500.svg`))
      .addSvgIcon('close-800', this.setPath(`${this.path}/27-icon-close-circle-800.svg`))
      .addSvgIcon('close-500', this.setPath(`${this.path}/27-icon-close-circle-500.svg`))
      .addSvgIcon('close-fill-800', this.setPath(`${this.path}/27-icon-close-circle-fill-800.svg`))
      .addSvgIcon('close-fill-500', this.setPath(`${this.path}/27-icon-close-circle-fill-500.svg`))
      .addSvgIcon('double-chevron-down-white', this.setPath(`${this.path}/27-icon-double-chevron-down-white.svg`));
  }

  private setPath(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
